export default __webpack_public_path__ + "static/media/photo-home-notif.daffd4c7.png";